exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 576px) {\n  .tabContent__adsContainer___2nVgG .tabContent__pagination___3wOc5 li[class*=\"ant-pagination-item\"] {\n    width: 20px; }\n    .tabContent__adsContainer___2nVgG .tabContent__pagination___3wOc5 li[class*=\"ant-pagination-item\"] > a {\n      font-size: 15px; } }\n\n.tabContent__adsContainer___2nVgG {\n  margin-top: 20px; }\n  @media (max-width: 576px) {\n    .tabContent__adsContainer___2nVgG {\n      margin-top: 15px; } }\n\n.tabContent__message___xzzJz {\n  margin-inline: 15px;\n  margin-top: 25px; }\n  .tabContent__message___xzzJz > a {\n    color: #a79265;\n    margin-left: 5px; }\n    .tabContent__message___xzzJz > a:hover {\n      color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"adsContainer": "tabContent__adsContainer___2nVgG",
	"pagination": "tabContent__pagination___3wOc5",
	"message": "tabContent__message___xzzJz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/MyAdsPage/MyAds/TabContent/tabContent.scss
// module id = 4978
// module chunks = 6